module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.04f08be1.ttf";